<template>
    <div style="min-width:900px;" class="mod-joylearning__courseinfo">
        <div class="pkg-search-box">
            <el-form class="pkg-content" label-position="left"
                     :model="dataForm"
                     @keyup.enter.native="getDataList()">
                <el-row class="margb10">
                    <el-col :span="7">
                        <!-- 品牌 -->
                        <el-form-item :label="$t('couse.brand')"
                                      class="search-item"
                                      prop="courseBrand">
                            <el-select v-model="brandQuery"
                                       multiple
                                       collapse-tags
                                       :placeholder="$t('course.select')">
                                <el-option v-for="(item,index) in courseBrandArr"
                                           :key="index"
                                           :label="item.name"
                                           :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 课程分类  class="padt5"-->
                        <el-form-item :label="$t('couse.coursecatalogid')"
                                      class="search-item">
                            <catalogtree @cateloglist="cateloglist"
                                         :defaultProps="defaultPropsz"
                                         :showArray="showVehicleClassList"
                                         :showValue="showValue"
                                         :url="queryTreeUrl"
                                         :isSelect=false
                                         :status="'classStatus'"
                                         ref="catalogtree"></catalogtree>

                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 课程类型 -->
                        <el-form-item :label="$t('couse.coursekind1')"
                                      class="search-item"
                                      prop="coursekind">
                            <el-select v-model="dataForm.coursekind"
                                       filterable
                                       clearable
                                       :placeholder="$t('course.select')">
                                <el-option v-for="(item,index) in newcourseKind"
                                           :key="index"
                                           :label="item.name"
                                           :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- 查询 -->
                    <el-col :span="3">
                        <el-col :span="24">
                            <el-button class="M-search"
                                       style="margin-bottom: 7px"
                                       type="primary"
                                       v-if="$hasPermission('learning:courseinfo:page')"
                                       @click="getDataListMerge">{{$t('course.query')}}</el-button>
                        </el-col>
                    </el-col>
                </el-row>
                <!-- ---->
                <el-row class="margb10">
                    <!-- 课程名称 -->
                    <el-col :span="7">
                        <el-form-item :label="$t('couse.coursename')"
                                      class="search-item">
                            <el-input v-model="dataForm.coursename"
                                      placeholder="课程代码/名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="7">
                        <!-- 课程状态 -->
                        <el-form-item :label="$t('couse.coursestatus')"
                                      class="search-item"
                                      prop="coursestatus">
                            <el-select v-model="dataForm.coursestatus"
                                       filterable
                                       clearable
                                       :placeholder="$t('course.select')">
                                <el-option v-for="(item,index) in newcoursestatus"
                                           :key="index"
                                           :label="item.name"
                                           :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <!-- 课程团队分类 course_team_catalog_id course.courseTeamCatalogId -->
                    <el-col :span="7">
                        <el-form-item prop="courseTeamCatalogFirst"
                                      class="search-item"
                                      :label="$t('couse.courseteamcatalogid')">
                            <div id="container" style="display: flex">
                                <div class="box01"
                                     style="width: auto; float: left;">
                                    <el-select v-model="dataForm.courseTeamCatalogFirst"
                                               placeholder="请选择"
                                               @change="GetcourseTeamCatalog($event)"
                                               clearable>
                                        <!-- <el-option v-for="item in select1"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value"> -->
                                        <el-option v-for="(item,index) in select1"
                                                   :key="index"
                                                   :label="item.name"
                                                   :value="item.code">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="box02"
                                     style="width: auto; float: left;">
                                    <el-select v-model="dataForm.courseTeamCatalogSecond"
                                               placeholder=" "
                                               :loading="loading"
                                               clearable>
                                        <el-option v-for="(item,index) in select2"
                                                   :key="index"
                                                   :label="item.name"
                                                   :value="item.code"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="3">
                        <!-- 重置 -->
                        <el-col :span="24">
                            <el-button class="el-back M-search M-margin-l"
                                       type="info"
                                       @click="again">{{$t('reset')}}</el-button>
                        </el-col>
                    </el-col>
                </el-row>

                <!-- 高级搜索 --->
                <div v-show="moreList">
                    <el-row class="margb10">
                        <el-col :span="7">
                            <!-- 课程标签-->
<!--                            <el-form-item class="search-item">-->
<!--                <span slot="label">-->
<!--                  <el-link type="primary" :underline="false" slot="reference"-->
<!--                           @click.native.prevent="showSuboSiteDlg">{{ $t('couse.courselabel')}}</el-link>-->
<!--                </span>-->
<!--                                <div class="el-input el-input&#45;&#45;default el-input__inner" style="height:30px; position: absolute;"  @mouseleave="trainerLabelLeave()" >-->
<!--                                    <div style="width:80%;float:left;" class="holder" contenteditable="false" :placeholder="$t('cert.selectTips')">{{this.dataForm.labelTypeName}}</div>-->
<!--                                    <el-link type="primary" :underline="false" class="el-icon-error link-delete-temp" ref="templateNameLink" v-show="dataForm.labelTypeName != '' && dataForm.labelTypeName != null" style="float:right;margin-top:9px;color:rgba(0,0,0,.3);" @click="trainerLabelName()"></el-link>-->
<!--                                </div>-->
<!--                                <div class="el-input el-input&#45;&#45;default is-disabled">-->
<!--                                    <input style=" "  type="text" autocomplete="off" placeholder="请选择" class="el-input__inner is-disabled" v-show="tagInputShow" >-->
<!--                                </div>-->
<!--                            </el-form-item>-->
                            <!--是否返还 -->
                                <el-form-item label="通过后返还"
                                              class="search-item"
                                              prop="whetherreturn">
                                    <el-select v-model="dataForm.whetherreturn"
                                               filterable
                                               clearable
                                               :placeholder="$t('course.select')">
                                        <el-option v-for="item in options"
                                                   :key="item.value"
                                                   :label="item.label"
                                                   :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <!-- 培训需要收集-->
                            <el-form-item :label="$t('couse.collectiondemandflag')"
                                          class="search-item">
                                <el-select v-model="dataForm.collectiondemandflag"
                                           filterable
                                           clearable
                                           :placeholder="$t('course.select')">
                                    <el-option v-for="(item,index) in newcourseProjectCF"
                                               :key="index"
                                               :label="item.name"
                                               :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <!-- 是否限制学习-->
                        <el-col :span="7">
                            <el-form-item :label="$t('couse.limitvisiableflag')"
                                          class="search-item">
                                <el-select v-model="dataForm.limitvisiableflag"
                                           filterable
                                           clearable
                                           :placeholder="$t('course.select')">
                                    <el-option v-for="(item,index) in newcourseProjectCF"
                                               :key="index"
                                               :label="item.name"
                                               :value="item.code">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="margb10">
                        <!-- 创建人-->
                        <el-col :span="7">
                            <el-form-item :label="$t('couse.createuser')"
                                          class="search-item">
                                <el-input v-model="dataForm.createuser"
                                          :placeholder="$t('course.plsin')"></el-input>
                            </el-form-item>
                        </el-col>
                        <!--创建时间 -->
                        <el-col :span="10">
                            <el-form-item :label="$t('couse.createtime')"
                                          class="search-item">
                                <el-date-picker v-model="createtime"
                                                type="daterange"
                                                value-format="yyyy-MM-dd"
                                                :start-placeholder="$t('couse.startdate1')"
                                                :end-placeholder="$t('couse.endData1')"
                                                :clearable="true"
                                                style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <el-row style="text-align: center; margin-bottom: 10px;">
                <el-col :span="24">
                    <div class="show-or-hide-icon"
                         v-bind:class="{ 'el-icon-arrow-up': moreList,
                                         'el-icon-arrow-down': !moreList }"
                         @click="moreList = !moreList">&nbsp;{{ moreList ? '收起' : '高级搜索' }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="pkg-content">
            <div class="search">
                <!--  -->
                <el-button type="primary" v-if="$hasPermission('learning:course:course')"
                           @click="changeRevise">{{ $t('add') }}</el-button>
                <!--     class="el-button-columnBtn"   -->
                <el-tooltip placement="top-start" effect="light" >
                    <div slot="content">{{ $t('couse.exportMsg') }}</div>
                    <el-button type="primary"  v-if="$hasPermission('learning:courseinfo:export')"
                               @click="exportHandle()">
                        {{ $t('export') }}
                        <em class="el-icon-question"></em>
                    </el-button>
                    <!--     class="el-button-columnBtn"      -->
                </el-tooltip>
            </div>
            <!-- 表头动态展示
            是否 courseProjectCF 10 yes 20 no
            // 课程类型 courseKind  10 面授 20 驻店 30 远程
            // 品牌类型 courseBrand    10 BMW 20 BMW Moto 30 MINI 40 ZINORO 50 SF
            // 课程状态 coursestatus 10 未发布 20 已发布 30 已下架
           -->
            <el-table ref="multipleTable"
                      v-loading="dataListLoading"
                      :data="dataList"
                      tooltip-effect="dark"
                      border
                      :row-style="{height:48+'px'}"
                      :cell-style="{padding:0+'px'}"
                      @selection-change="dataListSelectionChangeHandle">
                <!--style="height:527px; width: 100%;overflow:initial;"-->
                <el-table-column type="selection"
                                 header-align="center"
                                 align="center"
                                 width="50">
                </el-table-column>
                <!--序号-->
                <el-table-column :label="$t('couse.no')"
                                 type="index"
                                 :width="50"
                                 align="center"
                                 show-overflow-tooltip
                                 fixed>
                    <template slot-scope='scope'><span>{{(page-1)*limit + scope.$index+1}}</span></template>
                </el-table-column>
                <!--课程编号-->
                <el-table-column prop="courseCode"
                                 :label="$t('couse.coursecode')"
                                 header-align="center"
                                 align="center"
                                 width="110"
                                 show-overflow-tooltip
                                 fixed></el-table-column>
                <!--课程中文名称-->
                <el-table-column prop="courseNameCn"
                                 :label="$t('couse.coursenamecn')"
                                 header-align="center"
                                 align="left"
                                 width="180"
                                 show-overflow-tooltip
                                 fixed></el-table-column>
                <!--课程英文名称-->
                <el-table-column prop="courseNameEn"
                                 :label="$t('couse.coursenameen')"
                                 header-align="center"
                                 align="left"
                                 show-overflow-tooltip
                                 width="180"></el-table-column>
                <!--品牌-->
                <el-table-column prop="courseBrand"
                                 :label="$t('couse.brand')"
                                 header-align="center"
                                 align="center"
                                 width="100"
                                 show-overflow-tooltip
                                 :formatter="BrandFormat"></el-table-column>
                <!--课程状态-->
                <el-table-column prop="courseStatus"
                                 :label="$t('couse.coursestatus')"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :formatter="coursestatusformat"></el-table-column>
                <!--创建人  :formatter="createuserFormat" -->
                <el-table-column prop="createUserNameCn"
                                 :label="$t('couse.createuser')"
                                 header-align="center"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!--需求人数-->
                <el-table-column prop="courseDemand"
                                 :label="$t('couse.count')"
                                 header-align="center"
                                 show-overflow-tooltip
                                 align="center">
                    <template slot-scope="sc"
                              style="width: 130px; float: left;">
                        <div v-if="sc.row.collectionDemandFlag==10">
                            <!--              style="color: #409eff;"-->
                            <el-dropdown-item class="el-dropdown-link"
                                    @click.native="showViewapp(sc)">{{ sc.row.courseDemand }}</el-dropdown-item>
<!--                            {{ sc.row.courseDemand }}-->
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                </el-table-column>
                <!--创建时间-->
                <el-table-column prop="createTime"
                                 :label="$t('couse.createtime')"
                                 header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :formatter="dateFormat"></el-table-column>
                <!--标准时长（天）-->
                <el-table-column prop="courseDays"
                                 :label="$t('couse.coursedays')"
                                 :formatter="courseDaysformat"
                                 header-align="center"
                                 width="100"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!--间隔时长（天）-->
                <!-- <el-table-column prop="intervalTime"
                                 :label="$t('couse.intervalTime')"
                                 :formatter="intervalTimeformat"
                                 header-align="center"
                                 width="100"
                                 show-overflow-tooltip
                                 align="center"></el-table-column> -->
                <!--最大人数-->
                <el-table-column prop="maxNumber"
                                 :label="$t('couse.maxnumber')"
                                 header-align="center"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!--最小人数-->
                <el-table-column prop="minNumber"
                                 :label="$t('couse.minnumber')"
                                 header-align="center"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!--课程类型-->
                <el-table-column prop="courseKind"
                                 :label="$t('couse.coursekind1')"
                                 header-align="center"
                                 :formatter="coursekindformat"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!-- 课程标签 -->
                <!--        <el-table-column prop="courseLabel"-->
                <!--                         :label="$t('couse.courselabel')"-->
                <!--                         header-align="center"-->
                <!--                         show-overflow-tooltip-->
                <!--                         align="center">-->
                <!--                      <template slot-scope="scope">-->
                <!--                        <el-tooltip :content="scope.row.courseLabel" v-if="scope.row.courseLabel != null && scope.row.courseLabel != ''" :open-delay="openDelay" placement="top">-->
                <!--                          <div class="link-type link-label">标签</div>-->
                <!--                        </el-tooltip>-->
                <!--                      </template>-->
                <!--        </el-table-column>-->
                <el-table-column header-align="center"
                                 align="center"
                                 show-overflow-tooltip
                                 :label="$t('couse.courselabel')">
                    <template slot-scope="scope">
                        <!--查看-->
                        <span class="el-dropdown-link"
                              v-if="scope.row.courseLabel !== null && scope.row.courseLabel !== ''"
                              @click="checkLable(scope.row)">{{ $t('res.vehinfo.check') }}</span>
                    </template>
                </el-table-column>
                <!--培训需求收集-->
                <el-table-column prop="collectionDemandFlag"
                                 :label="$t('couse.collectiondemandflag')"
                                 header-align="center"
                                 width="100"
                                 :formatter="demandformat"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!--是否限制学习-->
                <el-table-column prop="limitVisiableFlag"
                                 :label="$t('couse.limitvisiableflag')"
                                 header-align="center"
                                 :formatter="limitformat"
                                 width="100"
                                 show-overflow-tooltip
                                 align="center"></el-table-column>
                <!--操作 -->
                <el-table-column :label="$t('offering.operation')"
                                 fixed="right"
                                 header-align="center"
                                 align="center"
                                 width="150">
                    <template slot-scope="scope">
                        <div>
                            <span class="el-dropdown-link" v-if="$hasPermission('learning:course:courseShow')" @click="showView(scope)">{{ $t('view') }}</span>
                            <div class="pkg-vertical-divider"></div>
                            <el-dropdown trigger="click"
                                         placement="bottom">

                <span class="el-dropdown-link">
                  {{ $t('offering.more') }}<em class="el-icon-caret-bottom el-icon--right"></em>
                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <!--显示编辑按钮 -->
                                    <el-dropdown-item v-if="checkEditRole(scope.row)"
                                                      @click.native="changeBuild(scope.row)">
                                        {{ $t('couse.edit') }}
                                    </el-dropdown-item>
                                    <!--显示下架按钮-->
                                    <el-dropdown-item v-if="checkUndercarriageRole(scope.row)"
                                                      @click.native="keepoff(scope.row)">
                                        {{ $t('couse.undercarriage') }}
                                    </el-dropdown-item>
                                    <!--显示发布按钮-->
                                    <el-dropdown-item v-if="checkReleaseRole(scope.row)"
                                                      @click.native="keepon(scope.row)">
                                        {{ $t('couse.active') }}
                                    </el-dropdown-item>
                                    <!--显示排期按钮 @click.native="keepon(scope.row)"-->
                                    <el-dropdown-item v-if="checkOffringclassRole(scope.row)"
                                                      @click.native="offering(scope.row)">
                                        {{ $t('couse.offringclass') }}
                                    </el-dropdown-item>
                                    <!--删除 -->
                                    <el-dropdown-item v-if="checkDeleteRole(scope.row)"
                                                      @click.native="gotoView('delete', scope.row)">
                                        {{ $t('couse.delete') }}
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="limit"
                           :total="total"
                           layout="total, sizes, prev, pager, next, jumper"
                           @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 编辑 -->
        <add-or-update v-if="addOrUpdateVisible"
                       ref="addOrUpdate"
                       @refreshDataList="getDataList"></add-or-update>
        <!-- 标签查看 -->
        <el-dialog title="标签查看"
                   :visible="isShowLable"
                   width="70%"
                   :before-close="showLableClose">
            <el-form label-position="top"
                     label-width="150px"
                     :ref="dataForm"
                     ref="dataForm">
                <div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="tagName"
                                          style="width: 100%!important;">
                                <Tag :checkedList="checkList"
                                     :brandCode="1"
                                     @changeCheckedList="changeCheckedListShow"
                                     @fatherMethod="fatherMethodShow"></Tag>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </el-dialog>
        <!--标签查询条件-->
        <el-dialog title="选择标签"
                   :visible="isQueryShowLable"
                   width="70%"
                   :before-close="showQueryLableClose">
            <el-form label-position="top"
                     label-width="150px"
                     :ref="dataForm"
                     ref="dataForm">
                <div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item prop="tagName"
                                          style="width: 100%!important;">
                                <tag :checkedList="courseTreeList"
                                     :overLabelShow = "true"
                                     :closeShow = "true"
                                     :brandCode="bussinessTypeChecked"
                                     @changeCheckedList="changeCheckedList"
                                     ref='tagTree'
                                     @fatherMethod="fatherMethod"></tag>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div>
                <el-button type="primary"
                           @click="onOkLable">{{ $t('res.rela.determine') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    // import Vue from 'vue'
    import catalogtree from '../common/catalogtree'
    // import courseTeamCatalogtree from '../common/courseTeamCatalogtree'
    import mixinViewModule from '@/mixins/view-module'
    import ToggleDiv from '@/components/toggle-div'
    import ClassTree from '../common/class-tree/index'
    import Tag from '@/components/learning/label-select/index'
    // import Tag from '@/components/learning/label-select/courselabel'
    // import AddOrUpdate from './courseinfo-add-or-update'
    export default {
        mixins: [mixinViewModule],
        data () {
            let _this = this
            return {
                tagInputShow: true,
                isShowLable: false,
                bussinessTypeChecked: null,
                isQueryShowLable: false,
                showOverflowTooltip: true,
                vehicleLabelShowFlg: true,
                checkList: [],
                // 课程分类树
                defaultPropsz: {
                    children: 'children',
                    label: 'catalogNameCn',
                    id: 'catalogId'
                },
                showVehicleClassList: [],
                showValue: '',
                queryTreeUrl: '/learning/coursecatalog/list',
                queryclassroomUrl: '/learning/courseinfo/courseLabelTree',
                // 课程团队树
                defaultPropsVisible: {
                    children: 'children',
                    label: 'catalogNameCn',
                    id: 'catalogId'
                },
                openDelay: 300,
                showVehicleClassListVisible: [],
                showValueVisible: '',
                queryTreeUrlVisible: '/learning/coursecatalog/list',
                mixinViewModuleOptions: {
                    getDataListURL: '/learning/courseinfo/page',
                    getDataListIsPage: true,
                    deleteURL: '/learning/courseinfo/delete',
                    undercarriageURL: 'learning/courseinfo/undercarriage'
                    // deleteIsBatch: true
                },
                dataList: [],
                // 是否 courseProjectCF
                newcourseProjectCF: _this.enums['courseProjectCF'],
                // 课程类型
                newcourseKind: _this.enums['courseKind'],
                // 品牌类型
                courseBrandArr: _this.enums['courseBrand'],
                // 课程状态
                newcoursestatus: _this.enums['courseStatus'],
                brandstr: '', // hiden
                createtime: '', // TODO
                courseMultipleSelection: [],
                dataForm: {
                    catalogId: '', // 课程分类
                    courseTeamCatalogId: '', // 课程团队分类
                    courseTeamCatalogFirst: '',
                    courseTeamCatalogSecond: '', // 课程团队分类
                    courseId: '',
                    courseBrand: [], // 品牌
                    coursename: '', // 课程名称
                    coursestatus: '', // 课程状态
                    coursekind: '', // 课程类型
                    courseLabel: '', // 课程标签
                    collectiondemandflag: '', // 培训需求收集
                    limitvisiableflag: '', // 是否限制学习
                    createuser: '', // 创建人
                    startTime: '',
                    endTime: '',
                    classroominfoList: '',
                    courseTreeList: [], // 课程标签
                    classRoomStatus: '',
                    whetherreturn:''

                },
                LableCheckShow: [],
                courseTreeList: [], // 课程标签
                select1: _this.enums['catalogidList1'],
                allteamcatalog: _this.enums['catalogidList2'],
                // select1: [
                //   { value: '10', label: 'BBS-50' },
                //   { value: '20', label: 'BBS-51' },
                //   { value: '30', label: 'BBS-52' },
                //   { value: '40', label: 'BBS-53' },
                //   { value: '50', label: 'H5' },
                //   { value: '60', label: 'Non TA' }],
                loading: false,
                select2: [],
                // allteamcatalog: [
                //   { pro: '10', label: '50' },
                //   { pro: '20', label: 'BP' }, { pro: '20', label: 'ME' }, { pro: '20', label: 'Others' },
                //   { pro: '30', label: 'MA' }, { pro: '30', label: 'S&M' }, { pro: '30', label: 'Others' },
                //   { pro: '40', label: 'Parts' }, { pro: '40', label: 'Service' }, { pro: '40', label: 'Others' }, { pro: '40', label: 'CCM' },
                //   { pro: '50', label: 'H5' },
                //   { pro: '60', label: 'CRM Coaching' }, { pro: '60', label: 'AS Coaching' }, { pro: '60', label: 'SF' }
                commLabelProps: {
                    children: 'children',
                    label: 'labelNameCn'
                },
                // ],
                couresList: [], // 课程分类使用
                couresListVisible: false, // 课程分类使用
                catalogidList: [], // 课程团队分类用
                catalogidListVisible: false, // 课程团队分类用
                // 展示更多
                showBrand: true,
                userTableData: [],
                // 等待转圈
                dataListLoading: false,
                moreList: false,
                checkAll: false,
                brandQuery: [],
                // 设置按钮pop状态
                visible: false,
                options: [{
                    value: '0',
                    label: '不返还'
                }, {
                    value: '1',
                    label: '返还'
                }]
            }
        },
        components: {
            Tag,
            ToggleDiv,
            catalogtree,
            'class-tree': ClassTree
        },

        methods: {
            showLableClose(){
                this.isShowLable = false
            },
            //  列表 课程标签查询
            checkLable(row){
                this.isShowLable = true

                console.info('hgjghj')
                console.info(row)
                console.info(row.courseLabel)
                console.info('qwerbcvbcbqwer')
                this.checkList = []
                let checkListtemp = row.courseLabel.trim().split(',')
                checkListtemp.forEach(o => {
                    if(o !== '' && o !== null){
                        let row = {}
                        row.labelName = o
                        this.checkList.push(row)
                    }
                })
                // this.dataForm.LableCheckShow = this.checkList
                this.LableCheckShow = this.checkList
                console.log( this.checkList)
            },
            trainerLabelLeave () {
                this.vehicleLabelShowFlg = false
            },
            // 课程标签 点击x 清空
            trainerLabelName () {
                this.dataForm.courseLabel = []
                this.dataForm.labelTypeName = ''
                this.courseTreeList = []
                this.vehicleLabelShowFlg = false
                try{
                    this.$refs.tagTree.isReset()
                } catch(e) {
                    console.log(e)
                }
                this.tagInputShow = true
            },
            // 重新勾选业务标签
            fatherMethodShow () {
                this.checkList = []
                // let checkListtemp = this.dataForm.LableCheckShow
                let checkListtemp = this.LableCheckShow
                checkListtemp.forEach(o => {
                    if(o !== '' && o !== null){
                        let row = {}
                        row.labelName = o.labelName
                        this.checkList.push(row)
                    }
                })
            },
            // 重新勾选业务标签
            fatherMethod () {
                console.log('查看 fatherMethod')
                this.courseTreeList = []
                // 已选择的标签
                this.courseTreeList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
                // this.courseTreeList = this.checkList ? this.checkList : []
                // 特殊情况，自己国际化
                this.courseTreeList.forEach(o => {
                    o.labelName = o.labelNameCn
                })
            },
            changeCheckedList (array) {
                this.courseTreeList = array
            },
            changeCheckedListShow (array) {
                this.checkList = array
            },
            showQueryLableClose(){
                this.isQueryShowLable = false
            },
            showSuboSiteDlg () {
                this.isQueryShowLable = true
            },
            onOkLable(){
                console.info('132564')
                console.info(this.courseTreeList)
                console.info('56465879')
                let args = this.courseTreeList
                if (args && args !== '' && args.length > 0) {
                    let trainerLabelinfo = []
                    let trainerLabelinfoName = []
                    args.forEach(function (item) {
                        trainerLabelinfo.push(item.labelId)
                        trainerLabelinfoName.push(item.labelName)
                    })
                    this.dataForm.courseLabel = trainerLabelinfo
                    this.dataForm.labelTypeName = trainerLabelinfoName.join(',')
                    console.info(this.dataForm.courseLabel)
                    console.info(this.dataForm.labelTypeName)
                    this.tagInputShow = false
                } else {
                    this.dataForm.courseLabel = []
                    this.dataForm.labelTypeName = ''
                    this.tagInputShow = true
                }
                this.isQueryShowLable = false
            },
            getClassroomList (args) {
                let courseLabel = []
                args.forEach(function (item) {
                    courseLabel.push(item.id)
                })
                this.dataForm.courseLabel = courseLabel.join(',')
            },
            // 课程分类调用树
            cateloglist: function (data) {
                let catalogId = ''
                let catalogNameCn = ''
                data[0].data.forEach(rows => {
                    catalogId = catalogId + rows.catalogId + ','
                    catalogNameCn = catalogNameCn + rows.catalogNameCn + ','
                })
                // this.$message(catalogId)
                this.dataForm.catalogId = catalogId
                // this.$message(catalogId)
            },
            // 课程团队分类调用树
            catalogidListVisiblelist: function (data) {
                let catalogId = ''
                let catalogNameCn = ''
                data[0].data.forEach(rows => {
                    catalogId = catalogId + rows.catalogId + ','
                    catalogNameCn = catalogNameCn + rows.catalogNameCn + ','
                })
                // this.$message(catalogId)
                this.dataForm.courseTeamCatalogId = catalogId
            },
            // 新增
            changeRevise () {
                this.$router.push({
                    name: 'learning-course-course'
                })
                this.$eventHub.$emit('addCourse', '')
            },
            // 修改
            changeBuild (row) {
                this.$router.push({ path: 'learning-course-course', query: { courseId: row.courseId } })
                this.$eventHub.$emit('showCourse', '')
            },
            // 查看
            showView (scope) {
                this.$router.push({ path: 'learning-course-courseShow', query: { courseId: scope.row.courseId } })
                this.$eventHub.$emit('showViewCourse', '')
            },
            // 查看开课申请详情
            showViewapp (scope) {
                this.$router.push({ path: 'learning-course-courseDemandApplyinfo', query: { courseId: scope.row.courseId ,coursename: scope.row.courseCode+'-'+scope.row.courseNameCn } })
            },
            // 查询
            getDataListMerge () {
                this.page = 1
                if (this.brandQuery != null || this.brandQuery !== '') {
                    this.dataForm.courseBrand = this.brandQuery + ''
                }
                if (this.createtime === null || this.createtime === '') {
                    this.dataForm.createtime = null
                }
                if (this.createtime != null && this.createtime !== '') {
                    this.dataForm.createtime = this.createtime + ''
                }
                this.getDataList()
            },
            // 重置
            again () {
                this.showVehicleClassList = []
                this.brandQuery = ''
                this.$refs.catalogtree.resetChecked()
                // this.$refs.Tag.deleteTag()
                this.trainerLabelName()
                this.createtime = ''
                this.dataForm = {
                    catalogId: '', // 课程分类
                    courseTeamCatalogId: '', // 课程团队分类
                    courseTeamCatalogFirst: '',
                    courseTeamCatalogSecond: '', // 课程团队分类
                    courseId: '',
                    courseBrand: '', // 品牌
                    coursename: '', // 课程名称
                    coursestatus: '', // 课程状态
                    coursekind: '', // 课程类型
                    courseLabel: '', // 课程标签
                    collectiondemandflag: '', // 培训需求收集
                    limitvisiableflag: '', // 是否限制学习
                    createuser: '', // 创建人
                    startTime: '',
                    endTime: '',
                    courseTreeList: []
                }
                this.courseTreeList = []
                // this.select1 = [
                //   { value: '10', label: 'BBS-50' },
                //   { value: '20', label: 'BBS-51' },
                //   { value: '30', label: 'BBS-52' },
                //   { value: '40', label: 'BBS-53' },
                //   { value: '50', label: 'H5' },
                //   { value: '60', label: 'Non TA' }]
                this.loading = false
                this.select2 = []
                // this.allteamcatalog = [
                //   { pro: '10', label: '50' },
                //   { pro: '20', label: 'BP' }, { pro: '20', label: 'ME' }, { pro: '20', label: 'Others' },
                //   { pro: '30', label: 'MA' }, { pro: '30', label: 'S&M' }, { pro: '30', label: 'Others' },
                //   { pro: '40', label: 'Parts' }, { pro: '40', label: 'Service' }, { pro: '40', label: 'Others' }, { pro: '40', label: 'CCM' },
                //   { pro: '50', label: 'H5' },
                //   { pro: '60', label: 'CRM Coaching' }, { pro: '60', label: 'AS Coaching' }, { pro: '60', label: 'SF' }

                // ]
                this.getDataListMerge()
            },
            // 操作列下拉选项
            gotoView (type, id) {
                if (type === 'view') {
                    this.$router.push({
                        name: 'coure-position',
                        query: {
                            orgId: id
                        }
                    })
                } else if (type === 'delete') {
                    this.deleteCourse(id)
                }
            },
            // 排期
            offering (row) {
                this.$router.push({ path: 'learning-offering-offeringEdit', query: { courseId: row.courseId } })
                this.$eventHub.$emit('coursebaseAdd', '')
            },
            keepoff (row) {
                let mesg = (this.$t('course.undercarriagemsg') + '<br/><br/>' + this.$t('prompt.info', { 'handle': this.$t('couse.undercarriage') }))
                this.$confirm(mesg, this.$t('prompt.title'), {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: this.$t('confirm'),
                    cancelButtonText: this.$t('cancel')
                }).then(() => {
                    this.$request.post(
                        `/learning/courseinfo/undercarriage`,
                        {
                            courseId: row.courseId
                        }
                    ).then((res, total, code, data) => {
                        console.log('undercarriage')
                        if (data.code === 12000000) {
                            this.$message({
                                message: this.$t('course.undercarriagewarn'),
                                type: 'warn',
                                duration: 5000,
                                onClose: () => {
                                    console.log('onClose')
                                }
                            })
                        } else if (data.code === 1) {
                            this.$message({
                                message: this.$t('prompt.success'),
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataListMerge()
                                }
                            })
                        } else {
                            this.$message({
                                message: '其他异常，请联系管理员！',
                                type: 'info',
                                duration: 3000,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                }).catch((err) => {
                    console.log(err)
                })
            },
            keepon (row) {
                this.$confirm(this.$t('prompt.info', { 'handle': this.$t('couse.active') }), this.$t('prompt.title'), {
                    confirmButtonText: this.$t('confirm'),
                    cancelButtonText: this.$t('cancel')
                }).then(() => {
                    this.$request.post(
                        `/learning/courseinfo/undercarriage`,
                        {
                            courseId: row.courseId
                        }
                    ).then((res, total, code, data) => {
                        console.log('undercarriage')
                        if (data.code === 12000000) {
                            this.$message({
                                message: data.msg,
                                type: 'warn',
                                duration: 5000,
                                onClose: () => {
                                    console.log('onClose')
                                }
                            })
                        } else {
                            this.$message({
                                message: this.$t('prompt.success'),
                                type: 'success',
                                duration: 3000,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        }
                    }).catch((err) => {
                        console.log(err)
                    })
                }).catch((err) => {
                    console.log(err)
                })
            },
            // 删除
            deleteCourse (row) {
                this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
                    confirmButtonText: this.$t('confirm'),
                    cancelButtonText: this.$t('cancel')
                }).then(() => {
                    this.$request.post(
                        this.mixinViewModuleOptions.deleteURL,
                        {
                            courseId: row.courseId
                        }
                    ).then((res, total, code, data) => {
                        if (data.code === 12000000) {
                            this.$message({
                                message: this.$t('course.deletewarn'),
                                type: 'warn',
                                duration: 5000,
                                onClose: () => {
                                    console.log('onClose')
                                }
                            })
                        } else {
                            this.$message({
                                message: this.$t('prompt.success'),
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataListMerge()
                                }
                            })
                        }
                    }).catch(() => {
                        console.log(' this.$message')
                    })
                }).catch((err) => {
                    console.log(err)
                })
            },
            toggle (val) {
                this.isShow = val
            },
            GetcourseTeamCatalog (prov) {
                let tempArry = []
                this.select2 = []
                if (this.dataForm.courseTeamCatalogSecond !== null || this.dataForm.courseTeamCatalogSecond === '') {
                    this.dataForm.courseTeamCatalogSecond = ''
                }
                // this.$message('***' + JSON.stringify(this.allteamcatalog))
                for (var val of this.allteamcatalog) {
                    var code = val.code.slice(0, 2)
                    if (prov === code) {
                        tempArry.push({ name: val.name, code: val.code })
                    }
                    this.select2 = tempArry
                }
            },
            // GetcourseTeamCatalog (prov) {
            //   let tempArry = []
            //   this.select2 = []
            //   if (this.dataForm.courseTeamCatalogSecond !== null || this.dataForm.courseTeamCatalogSecond === '') {
            //     this.dataForm.courseTeamCatalogSecond = ''
            //   }
            //   for (var val of this.allteamcatalog) {
            //     if (prov === val.pro) {
            //       tempArry.push({ label: val.label, value: val.label })
            //     }
            //     this.select2 = tempArry
            //   }
            // },
            // 勾选数据
            dataListSelectionChangeHandle (val) {
                // console.log(val)
                for (let i = 0; i < val.length; i++) {
                    this.courseMultipleSelection.push(val[i].courseId)
                }
                // this.courseMultipleSelection.push(val.courseId)
                console.log(this.courseMultipleSelection)
            },
            // 批量导出
            exportHandle () {
                console.log('xxx')
                console.log(this.$refs.multipleTable.selection)

                let selection = this.$refs.multipleTable.selection
                let checkSel = []
                for (let i = 0; i < selection.length; i++) {
                    checkSel.push(selection[i].courseId)
                }
                // download 参数 url, params, 报表名
                this.$request.downloadLearning('/learning/courseinfo/export', this.$t('couse.courseExport'),
                    {
                        ...this.dataForm,
                        page: this.page,
                        limit: this.limit,
                        courseMultipleSelection: checkSel
                    }
                )
            },
            // createuserFormat(row, column, cellValue){
            //     var createuser = row.cre
            // },
            courseDaysformat (row, column, cellValue) {
                try{
                    return cellValue.toFixed(2)
                } catch (e) {
                    return cellValue
                }
            },
            dateFormat (row, column, cellValue) {
                return cellValue.split(' ')[0]
            },
            coursestatusformat (row, column, cellValue) {
                if (cellValue === '10') {
                    return '未发布'
                } else if (cellValue === '20') {
                    return '已发布'
                } else if (cellValue === '30') {
                    return '已下架'
                } else { return ' ' }
            },
            coursekindformat (row, column, cellValue) {
                if (cellValue === '10') {
                    return '面授课程'
                } else if (cellValue === '20') {
                    return '驻店培训'
                } else if (cellValue === '30') {
                    return '远程培训'
                } else { return ' ' }
            },
            demandformat (row, column, cellValue) {
                if (cellValue === '10') {
                    return '是'
                } else if (cellValue === '20') {
                    return '否'
                } else { return ' ' }
            },
            limitformat (row, column, cellValue) {
                if (cellValue === '10') {
                    return '是'
                } else if (cellValue === '20') {
                    return '否'
                } else { return ' ' }
            },
            BrandFormat (row, column, cellValue) {
                var temp = []
                if (cellValue != null) {
                    var list = cellValue.split(',')
                    for (let index = 0; index < list.length; index++) {
                        if (list[index] === '10') {
                            temp.push('BMW')
                        } else if (list[index] === '20') {
                            temp.push('BMW Motorrad')
                        } else if (list[index] === '30') {
                            temp.push('MINI')
                        } else if (list[index] === '40') {
                            temp.push('ZINORO')
                        }
                        // else if (list[index] === '50') {
                        //   temp.push('SF')
                        // }
                    }

                    return temp.join(',')
                }
            },
            // 查看
            checkShowRole (row) {
                if (this.$hasPermission('learning:courseinfo:offeringShow')) {
                    return true
                }
                return false
            },
            // 编辑
            checkEditRole (row) {
                if (this.$hasPermission('learning:courseinfo:edit')) {
                    return true
                }
                if (this.$hasPermission('TEAM:'+row.courseTeamCatalogSecond)) {
                    return true
                }
                if (this.$hasPermission('learning:courseinfo:editselfcreated')) {
                    return true
                }
                return false
            },
            // 删除
            checkDeleteRole (row) {
                if (row.courseStatus !== '10') {
                    return false
                }
                if (this.$hasPermission('learning:courseinfo:delete')) {
                    return true
                }
                if (this.$hasPermission('TEAM:'+row.courseTeamCatalogSecond)) {
                    return true
                }
                return false
            },
            // 复制
            checkCopyRole (row) {
                if (this.$hasPermission('learning:courseinfo:copyCourse')) {
                    return true
                }
                if (this.$hasPermission('TEAM:'+row.courseTeamCatalogSecond)) {
                    return true
                }
                return false
            },
            // 下架
            checkUndercarriageRole (row) {
                if (row.courseStatus !== '20') {
                    return false
                }
                if (this.$hasPermission('learning:courseinfo:undercarriage')) {
                    return true
                }
                if (this.$hasPermission('TEAM:'+row.courseTeamCatalogSecond)) {
                    return true
                }
                return false
            },
            // 发布
            checkReleaseRole (row) {
                if (row.courseStatus === '20') {
                    return false
                }
                if (this.$hasPermission('learning:courseinfo:release')) {
                    return true
                }
                if (this.$hasPermission('TEAM:'+row.courseTeamCatalogSecond)) {
                    return true
                }
                return false
            },
            // 排期
            checkOffringclassRole (row) {
                if (row.courseStatus !== '20') {
                    return false
                }
                if (this.$hasPermission('TEAM:'+row.courseTeamCatalogSecond)) {
                    return true
                }
                if (this.$hasPermission('learning:course:offeringEdit')) {
                    return true
                }
                return false
            }
            // 数据字典字段取值  共同不能用给未来预留
            // brandFormatter (row) {
            //   return Vue.filter('coverEnumList')(row.courseBrand, 'courseBrand', ',')
            // },
            // cstatusFormatter (row) {
            //   return Vue.filter('coverEnum')(row.coursestatus, 'coursestatus')
            // },
            // courseProjectFormatter (row) {
            //   return Vue.filter('coverEnum')(row.courseProjectCF, 'courseProjectCF')
            // },
            // courseProjectFormatter (row) {
            //   return Vue.filter('coverEnum')(row.courseKind, 'courseKind')
            // },
            // transbrand () {
            // console.log(this.brandQuery)
            // this.dataForm.courseBrand
            // console.log(this.data.courseBrand + 'data')
            // var Str = this.dataForm.courseBrand
            // console.log(Str)
            //
            // this.dataForm.courseBrand=
            // }
        }
    }
</script>
<style scoped lang="scss">
@import "../../../css/pkg-styles.css";
.el-date-editor.el-input {
  width: 150px;
}
.search-item  {
    width: 94%!important;
}
.el-row {
    margin-bottom: 0px;
}
.search {
    height: 50px;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.link-type:focus {
    color: #337ab7;
    cursor: pointer;
}
.link-type:hover {
    color: rgb(32, 160, 255);
}
.link-label:hover{
    cursor: pointer;
    text-decoration: none !important;
}
</style>
<style lang="scss">
.mod-joylearning__courseinfo {
    .search-item  {
        .el-form-item__content {
            margin-left: 96px !important;
        }
    }
}
</style>
